import { Routes, Route } from 'react-router-dom';
import { Home } from './routes/home';
import { Stack } from './routes/stack';
import { EnginesIndex } from './routes/engines';
import { EngineDetail } from './routes/engine-detail';
import { Playbook } from './routes/playbook';
import { Changelog } from './routes/changelog';
import { Signup } from './routes/signup';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/stack" element={<Stack />} />
      <Route path="/engines" element={<EnginesIndex />} />
      <Route path="/engines/:slug" element={<EngineDetail />} />
      <Route path="/playbook" element={<Playbook />} />
      <Route path="/changelog" element={<Changelog />} />
      <Route path="/signup" element={<Signup />} />
      {/* /login wired up in Task 1.19 */}
    </Routes>
  );
}
